// extracted by mini-css-extract-plugin
export default {"circles":"animatedeffects_circles__nO97R","animate":"animatedeffects_animate__nYluF"};